module.exports = __webpack_public_path__ + "static/media/synth-oof.32b25584.mp3";